import React from 'react';
import PropTypes from 'prop-types';

import Header from 'components/header';
import { useAuth } from 'context/auth';

const HeaderPublic = ({ sticky }) => {
  const { user } = useAuth();

  const routes = [
    {
      text: 'projects',
      path: '/projects',
    },
    {
      text: 'approach',
      path: '/approach',
    },
    {
      text: 'studio',
      path: '/studio',
    },
    {
      text: 'contact',
      path: '/studio#contact',
      mobile: true,
      hash: true,
    },
    {
      text: 'legal info',
      path: '/studio#legal-info',
      mobile: true,
      hash: true,
    },
  ];

  if (user?.token != null) {
    routes.push({
      text: 'admin',
      path: '/admin',
      nav: true,
    });
  }

  return <Header sticky={sticky} routes={routes} />;
};

HeaderPublic.propTypes = {
  sticky: PropTypes.bool,
};

HeaderPublic.defaultProps = {
  sticky: true,
};

export default HeaderPublic;
